/* eslint-disable no-useless-computed-key */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useCallback, useRef, useState } from 'react';
import customStyles from "../../../../../assets/styles/customStyles";
import MainHeader from "../../../../Shared/components/Header";
import SalesIcon from "../../../../../assets/images/icon_menus/SalesIcon.json";
import clsx from 'clsx';
import PrimaryCard from "../../../../Shared/components/Card/PrimaryCard";
import { Row, Col, Image, Space } from "antd";
import { TextField } from "@mui/material";
import ImportIcon from "../../../../../assets/images/icon_actions/Import.svg";
import ExportIcon from "../../../../../assets/images/icon_actions/Export.svg";
import { Link, NavLink } from "react-router-dom";
import SearchIcon from "../../../../../assets/images/icon_actions/Search Icon.svg";
import AddIcon from "../../../../../assets/images/icon_actions/Add Icon.svg";
//import FilterIcon from "../../../../../assets/images/icon_actions/Filter Icon.svg";
import { SelfBillTable } from "../../../../Sales/Management/components/SelfBills/SelfBillTable";
import { useDispatch, useSelector } from "react-redux";
import actions from "../../redux/actions";
import usePrevious from "../../../../Shared/components/Previous";
//import businessActions from "../../../../Admin/Home/redux/actions";
import crudActions from "../../../../CRUD/redux/actions";
import { checkViewPermission, checkCRUDPermission, checkComponentPermission, storageRemoveItem, getBusinessId, idNamingConversion } from '../../../../../helpers/utilities';
import { ImportExport } from '../../../../Shared/components/ImportExport';
import { useEventListener } from "../../../../../helpers/useEventListener";
import ClearIcon from "../../../../../assets/images/icon_actions/Clear Icon.svg";
import { getRequest } from '../../../../../helpers/axiosClient';


const SelfBills = (props) => {
    const { salesSelfBillDetails, loader } = useSelector(state => state.salesManagementReducer);
    const { roleManagement } = useSelector(state => state.authReducer);
    const { history } = props;
    const { getList, getData } = useSelector(state => state.crudReducer);
    const { businessDetails } = useSelector(state => state.homeReducer);
    const { productGstdetails, hsnDetails } = useSelector(state => state.adminSetupReducer);
    const dispatch = useDispatch();
    const [search, setSearch] = useState('');
    const [iconAnimation, setIconAnimation] = useState(false);
    const prevSearch = usePrevious(search);
    const [skip, setSkip] = useState(0);
    const timeoutRef = useRef(null);
    const limit = 25;
    const [sortOrder, setSortOrder] = useState("desc");
    const [sortBy, setSortBy] = useState("id");
    const [loadMore, setLoadMore] = useState(false);
    const [loadMoreContent, setLoadMoreContent] = useState(false);
    const [importVisible, setImportVisible] = useState(false);
    const [prefix, setPrefix] = useState('');

    useEffect(() => {
        if ((prevSearch !== undefined && search && search.length > 2 && prevSearch !== search) || (prevSearch !== undefined && search === '' && prevSearch !== search)) {
            if (timeoutRef.current !== null) {
                clearTimeout(timeoutRef.current);
            }
            if (search === '') {
                dispatchFilter(sortBy, sortOrder);
            } else {
                timeoutRef.current = setTimeout(() => {
                    timeoutRef.current = null;
                    dispatchFilter(sortBy, sortOrder);
                }, 500);
            }
        }
    }, [search]);

    useEffect(() => {
        if (roleManagement !== '') {
            if (checkViewPermission('Sales Bill', history, 'Sales')) {
                loadTasks();
                storageRemoveItem('salesView');
                checkPrefix();
            }
        }
    }, [roleManagement]);


    const checkPrefix = () => {
        let filter = { where: { ["and"]: [{ businessId: getBusinessId() }, { prefix: 'CI' }, { prefixType: 'MANUAL' }] } };
        let response = getRequest(`${process.env.REACT_APP_API_URL}/activity-counters?filter=${encodeURIComponent(JSON.stringify(filter))}`);

        response.then(payload => {
            // Handle the fetched data here
            let data = payload.data;
            if (data && data?.length) {
                setPrefix(data[0]);
            }
        }).catch(error => {
            // Handle any errors
        })
    }

    const handleKeyDown = (e) => {
        if (e.altKey && e.keyCode === 78) {
            e.preventDefault();
            history.push('/sales/sales-management/self-bill/create');
        }
    };

    useEventListener("keydown", handleKeyDown);

    const prevGetData = usePrevious(getData);
    useEffect(() => {
        if (loadMore && getData === '') {
            setLoadMoreContent(false);
            setLoadMore(true);
        }

        if (prevGetData !== undefined && getData && prevGetData !== getData) {
            const timer = setTimeout(() => {
                if (getData && Array.isArray(getData) && getData.length > 0) {
                    setLoadMore(true);
                    if (getData.length < limit) {
                        setLoadMoreContent(false);
                    } else {
                        setLoadMoreContent(true);
                    }
                } else {
                    setLoadMoreContent(false);
                    setLoadMore(true);
                }
            });

            return () => {
                clearTimeout(timer);
            };
        }
    }, [getData]);

    const dispatchFilter = (sortBy, sortOrder, skip = 0) => {
        if (skip === 0) {
            setLoadMore(false);
            setLoadMoreContent(false);
        }
        let filter = { or: [] };
        if (search !== '') {
            filter['or'].push({ serialNo: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ name: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ phone: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ invoiceAmount: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ billStatus: { like: '%' + search.trim() + '%' } });
        }
        setSkip(skip);
        
        dispatch({
            type: crudActions.GET_DETAILS_START,
            url: 'selfBill',
            skip: skip,
            filter: {
                where: !filter.or || filter.or.length === 0 ? {} : filter,
                order: sortBy + ' ' + sortOrder,
                limit: limit,
                skip: skip,
            }
        });
    }

    const loadTasks = useCallback(() => {
        dispatchFilter(sortBy, sortOrder);
    });


    const requestSort = (sortBy, sortOrder) => {
        setSortBy(sortBy);
        setSortOrder(sortOrder);
        dispatchFilter(sortBy, sortOrder);
    }

    const loadMoreTask = () => {
        let s = skip + limit;
        dispatchFilter(sortBy, sortOrder, s);
    }

    const loadImportExportData = (name, data = 'existing', selected = [], extension = 'xlsx') => {
        dispatch({
            type: actions.SALES_SELFBILL_DETAILS_START,
            export: name,
            data: data,
            selected: selected,
            extension: extension,
            url: 'selfBill',
            filter: {
                order: sortBy + ' ' + sortOrder,
            }
        });
    }


    const classes = customStyles();
    return (
        <React.Fragment>
            <MainHeader {...props}
                closeLink={'/sales'}
                cls={'newImg'} img={SalesIcon} title={'Sales'} links={[{ 'label': 'Sales', 'link': '/sales' }, { 'label': 'Sales Bill', 'link': '' }]} />
            <div className={clsx(classes.margin40, classes.listTableMargin)}>
                <PrimaryCard
                    title={'Sales Bill'}
                    component={
                        <>
                            <Row align="middle" className={classes.marginBottom20}>
                                <Col xxl={6} xl={7} lg={8} md={10} sm={14} xs={24}>
                                    {
                                        roleManagement !== '' && checkComponentPermission('Sales Bill', 'Action', 'Search') &&
                                        <div className={clsx(classes.searchAnimation, { [classes.iconAnimation]: iconAnimation || search !== '' })}>
                                            <TextField autoComplete='one-time-code'
                                                placeholder='Search SB No., Name, Ph. No., and Status'
                                                type='search'
                                                value={search}
                                                onChange={(e) => setSearch(e.target.value)}
                                                className={classes.comInput}
                                                variant={'standard'}
                                                fullWidth
                                                onFocus={() => setIconAnimation(true)}
                                                onBlur={() => setIconAnimation(false)}
                                                id={idNamingConversion('Search', 'salesBill', 'TextField')}
                                            />
                                            <Image
                                                src={SearchIcon}
                                                preview={false}
                                            />
                                            {
                                                search && <NavLink to="#" onClick={() => setSearch('')} className={classes.searchClear}>
                                                    <Image
                                                        src={ClearIcon}
                                                        preview={false}
                                                    />
                                                </NavLink>
                                            }
                                        </div>
                                    }
                                </Col>
                                <Col xxl={18} xl={17} lg={16} md={14} sm={10} xs={24}
                                    className={clsx(classes.textAlignRight, classes.vertiCalScrollOverFlowParent, classes.removeUnderline, classes.customerLabelNone)}>
                                    <div className={classes.vertiCalScrollOverFlow}>
                                        <Space size={[20, 20]} direction="horizontal" align="center">
                                            {
                                                roleManagement !== '' && checkComponentPermission('Sales Bill', 'Action', 'Export') &&
                                                <NavLink
                                                    to="#"
                                                    id={idNamingConversion('Export', 'salesBill', 'Link')}
                                                    onClick={() => { loadImportExportData('Salesselfbill'); }}
                                                    className={clsx(classes.customLink)}>
                                                    <Image
                                                        src={ExportIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Export</span>
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && checkComponentPermission('Sales Bill', 'Action', 'Import') &&
                                                <NavLink
                                                    to="#"
                                                    id={idNamingConversion('Import', 'salesBill', 'Link')}
                                                    onClick={() => { setImportVisible(true); }}
                                                    className={clsx(classes.customLink)}>
                                                    <Image
                                                        src={ImportIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Import</span>
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && checkCRUDPermission('Sales Bill', 'create', 'Sales') &&
                                                <Link
                                                    id={idNamingConversion('Create Credit Note', 'salesBill', 'Link')}
                                                    to={'/sales/sales-management/credit-note/create'}
                                                    // onClick={() => handleOpen()}
                                                    className={clsx(classes.customLink)}>
                                                    <Image src={AddIcon} preview={false} className={clsx(classes.antImage)}
                                                    /><span className={clsx(classes.addLink, classes.color, classes.bold)}>Create Credit Note</span>
                                                </Link>
                                            }
                                            {
                                                roleManagement !== '' && checkCRUDPermission('Sales Bill', 'create', 'Sales') &&
                                                <Link
                                                    id={idNamingConversion('Create Sales Bill', 'salesBill', 'Link')}
                                                    to={'/sales/sales-management/self-bill/create'}
                                                    // onClick={() => handleOpen()}
                                                    className={clsx(classes.customLink)}>
                                                    <Image src={AddIcon} preview={false} className={clsx(classes.antImage)}
                                                    /><span className={clsx(classes.addLink, classes.color, classes.bold)}>Create Sales Bill</span>
                                                </Link>
                                            }
                                            {
                                                roleManagement !== '' && checkComponentPermission('Sales Bill', 'Action', 'Filter') &&
                                                <></>
                                            }
                                        </Space>
                                    </div>
                                </Col>
                            </Row>
                            <SelfBillTable
                                search={search}
                                loadTasks={() => dispatchFilter(sortBy, sortOrder)}
                                details={getList}
                                loadMore={loadMore}
                                loadMoreContent={loadMoreContent}
                                loadMoreTask={() => loadMoreTask()}
                                productGstdetails={productGstdetails}
                                businessDetails={businessDetails}
                                sortOrder={sortOrder} sortBy={sortBy}
                                roleManagement={roleManagement}
                                hsnDetails={hsnDetails}
                                prefix={prefix}
                                onRequestSort={(sortBy, sortOrder) => requestSort(sortBy, sortOrder)} />
                        </>
                    }
                />
            </div>
            <ImportExport
                handleClose={() => { setImportVisible(false); }}
                visible={importVisible}
                title={'Sales bill'}
                type={'import'}
                loader={loader}
                loadImportExportData={(name, type, selected, extension) => loadImportExportData(name, type, selected, extension)}
                details={salesSelfBillDetails}
                loadTasks={() => { dispatchFilter(sortBy, sortOrder) }}
            />
        </React.Fragment>
    )
}
export default SelfBills 
